import {AfterViewInit, ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "angular2-social-login";
import {Conf} from "../settings/config";
import * as $ from "jquery/dist/jquery.min.js";
import {ShareButtons} from "@ngx-share/core";
import {MalihuScrollbarService} from "ngx-malihu-scrollbar";
import {User} from "../models/user.model";
import {AuthServices} from "../services/auth.service";
import {HeaderComponent} from "../header/header.component";
import {FunctionsService} from "../services/functions.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {DetailsComponent} from "../dialogs/details/details.component";

@Component({
    selector: 'app-accommodations',
    templateUrl: './accommodations.component.html'
})
export class AccommodationsComponent implements OnInit, AfterViewInit {
    public slug;
    accommodation = {
        "id": null,
        "title": null,
        "slug": null,
        "content": null,
        "address": null,
        "latitude": null,
        "longitude": null,
        "email": null,
        "phone": null,
        "opening_time": null,
        "closing_time": null,
        "fee": null,
        "website": null,
        "thumbnail_image": null,
        "center_distance": null,
        "area_title": null
    };
    facilities = [];

    // google map
    zoom: number = 16;

    lat: number;
    lng: number;

    markers = {
        "experiences": [],
        "properties": []
    };
    map_tab;

    infoWindow = null;

    galleryOptions = [
        {
            width: '800px',
            height: '750px',
            thumbnailsColumns: 4,
            imagePercent: 80,
            thumbnailsPercent: 17,
            thumbnailsMargin: 5,
            thumbnailMargin: 5
        },
    ];
    galleryImages = [];

    nearby = {
        'attractions': [],
        'shopping': [],
        'art-entertainment': [],
        'eat-drink': [],
        'current': []
    };

    nearby_tab;
    navleft = '<i class="icon-angle-left"></i>';
    navright = '<i class="icon-angle-right"></i>';

    rating_order = {};
    reviews_avg = {};
    reviews = [];
    next = null;

    auth_user = new User();

    rooms = [];
    roomImages = [];
    roomFacilities = [];

    bars = [];
    barImages = [];
    barFacilities = [];

    spas = [];
    spaImages = [];

    headersHeight: number;

    constructor(public header: HeaderComponent,
                private router: Router,
                private modalService: NgbModal,
                public share: ShareButtons,
                private route: ActivatedRoute,
                private http: HttpClient,
                public _auth: AuthService,
                private authService: AuthServices,
                private ref: ChangeDetectorRef) {

    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.slug = params['slug'];
            this.facilities = [];
            this.markers = {
                "experiences": [],
                "properties": []
            };

            this.map_tab = 'experiences';
            this.nearby_tab = 'attractions';

            this.galleryImages = [];

            this.reviews_avg = {}
            this.reviews = [];
            this.next = null;

            this.getAccommodation();

            this.authService.currentUser.subscribe((user: User) => {
                this.auth_user = user;
            });
        });
    }

    ngAfterViewInit(): void {
        this.headersHeight = $(window).width() > 991 ? $('#header').height() + $('div.fixed-nav').height() : $('.nav-parent').height();
        this.ref.detectChanges();
    }

    getAccommodation() {
        this.http.get(Conf.API_URL + '/accommodations/?slug=' + this.slug).subscribe(
            data => {
                if (data['results'].length) {
                    this.accommodation = data['results'][0];
                    this.lat = this.accommodation.latitude = parseFloat(this.accommodation.latitude);
                    this.lng = this.accommodation.longitude = parseFloat(this.accommodation.longitude);
                    this.infoWindow = 'current';

                    this.getAccommodationImages();
                    this.getAccommodationFacilities();

                    this.getRooms();
                    this.getBars();
                    this.getSpas();

                    this.getNearby();

                    this.getReviews();
                } else {
                    this.router.navigate(['/404']);
                    return false;
                }
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getAccommodationImages() {
        this.http.get(Conf.API_URL + '/accommodation-images/?show_all&accommodation__slug=' + this.slug).subscribe(
            data => {
                let self = this;

                $.each(data['results'], function (index, value) {
                    self.galleryImages.push({
                        small: value.image,
                        medium: value.image,
                        big: value.image
                    })
                });
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getReviews(type = 'All') {
        var url = Conf.API_URL + '/accommodation-reviews/?accommodation__slug=' + this.slug;
        var url_avg = Conf.API_URL + '/accommodation-reviews-avg/?accommodation=' + this.slug;
        if (type != 'All') {
            url += '&sort=' + type;
            url_avg += '&sort=' + type;
        }

        this.http.get(url_avg).subscribe(
            data => {
                this.reviews_avg = data['results'];
                this.rating_order = data['rating_order'];
            },
            error => {
                console.log(error.error)
            }
        );

        this.http.get(url).subscribe(
            data => {
                this.reviews = data['results'];
                this.next = data['next'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    loadMore() {
        this.http.get(this.next).subscribe(
            data => {
                this.reviews = this.reviews.concat(data['results']);
                this.next = data['next'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getNearby() {
        const url = Conf.API_URL + '/accommodation-nearby-properties/?category=all&slug=' + this.slug;

        this.http.get(url).subscribe(
            data => {
                this.nearby = data['results'];
                let self = this;
                $.each(data['results'], function (category, things) {
                    $.each(things, function (index, value) {
                        if (category == 'current') {
                            self.markers['properties'].push({
                                index: index,
                                lat: parseFloat(value.latitude),
                                lng: parseFloat(value.longitude),
                                area: value.area,
                                id: category + value.id,
                                category: category,
                                distance: value.distance,
                                gm_distance: value.gm_distance,
                                title: value.title,
                                image: value.thumbnail_image,
                            });
                        } else {
                            self.markers['experiences'].push({
                                index: index,
                                lat: parseFloat(value.latitude),
                                lng: parseFloat(value.longitude),
                                area: value.area,
                                id: category + value.id,
                                category: category,
                                title: value.title,
                                image: value.thumbnail_image,
                                distance: value.distance,
                                gm_distance: value.gm_distance,
                            });
                        }
                    });
                });
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getAccommodationFacilities() {
        this.http.get(Conf.API_URL + '/accommodation-facilities-in-groups/?accommodation=' + this.accommodation.id).subscribe(
            data => {
                this.facilities = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getRooms() {
        this.http.get(Conf.API_URL + '/rooms/?show_all&accommodation=' + this.accommodation.id).subscribe(
            data => {
                this.rooms = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getRoomImages(room) {
        this.http.get(Conf.API_URL + '/room-images/?show_all&room=' + room).subscribe(
            data => {
                let self = this;
                $.each(data['results'], function (index, value) {
                    self.roomImages.push({
                        small: value.image,
                        medium: value.image,
                        big: value.image
                    })
                });
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getRoomFacilities(room, callback) {
        this.http.get(Conf.API_URL + '/room-facilities-in-groups/?room=' + room).subscribe(
            data => {
                this.roomFacilities = data['results'];
                callback();
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getBars() {
        this.http.get(Conf.API_URL + '/restaurants-for-accommodation/?accommodation=' + this.accommodation.id).subscribe(
            data => {
                this.bars = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getBarImages(bar) {
        this.http.get(Conf.API_URL + '/restaurant-images/?show_all&restaurant=' + bar).subscribe(
            data => {
                let self = this;
                $.each(data['results'], function (index, value) {
                    self.barImages.push({
                        small: value.image,
                        medium: value.image,
                        big: value.image
                    })
                });
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getBarFacilities(bar, callback) {
        this.http.get(Conf.API_URL + '/restaurant-facilities-in-groups/?restaurant=' + bar).subscribe(
            data => {
                this.barFacilities = data['results'];
                callback();
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getSpas() {
        this.http.get(Conf.API_URL + '/accommodation-spa-list/?accommodation=' + this.accommodation.id).subscribe(
            data => {
                this.spas = data['results'];
            },
            error => {
                console.log(error.error)
            }
        );
    }

    getSpaImages(spa) {
        this.http.get(Conf.API_URL + '/spa-images/?show_all&spa=' + spa).subscribe(
            data => {
                let self = this;
                $.each(data['results'], function (index, value) {
                    self.spaImages.push({
                        small: value.image,
                        medium: value.image,
                        big: value.image
                    })
                });
            },
            error => {
                console.log(error.error)
            }
        );
    }

    selectMapTab(tab) {
        this.map_tab = tab;
        this.lat = this.accommodation.latitude;
        this.lng = this.accommodation.longitude;
        this.infoWindow = 'current'
    }

    openLogin() {
        this.header.openLogin()
    }

    clickedMarker(category: string, item: any) {
        this.lat = parseFloat(item.latitude);
        this.lng = parseFloat(item.longitude);
        this.infoWindow = category + item.id;
    }

    firstParagraph(html) {
        return FunctionsService.firstParagraph(html)
    }

    openRoomDetails(index) {
        if (this.rooms[index]) {
            let self = this;
            let room = this.rooms[index];
            this.getRoomImages(room['id']);

            this.getRoomFacilities(room['id'], function () {
                const modalRef = self.modalService.open(DetailsComponent, {size: "lg"});

                modalRef.componentInstance.type = 'room';
                modalRef.componentInstance.data = room;
                modalRef.componentInstance.galleryImages = self.roomImages;
                modalRef.componentInstance.facilities = self.roomFacilities;
            });
        }

    }

    openBarDetails(index) {
        if (this.bars[index]) {
            let self = this;
            let bar = this.bars[index];
            this.getBarImages(bar['id']);

            this.getBarFacilities(bar['id'], function () {
                const modalRef = self.modalService.open(DetailsComponent, {size: "lg"});

                modalRef.componentInstance.type = 'bar';
                modalRef.componentInstance.data = bar;
                modalRef.componentInstance.galleryImages = self.barImages;
                modalRef.componentInstance.facilities = self.barFacilities;
            });
        }

    }

    openSpaDetails(index) {
        if (this.spas[index]) {
            let self = this;
            let spa = this.spas[index];
            this.getSpaImages(spa['id']);

            const modalRef = self.modalService.open(DetailsComponent, {size: "lg"});

            modalRef.componentInstance.type = 'spa';
            modalRef.componentInstance.data = spa;
            modalRef.componentInstance.galleryImages = self.spaImages;
        }

    }

    setTabActive($event): void {
        $('li.tab-link a').removeClass('active');
        $event.target.classList.add('active');
        if ($(window).width() < 991) {
            $('ul.toggle-content').slideToggle();
        }
    }

    splitData(html) {
        if (html)
            return html.split(/\n/);
        else
            return '';
    }

    getNearbyLinks(tab: string, item: any): string {
        switch (tab) {
            case 'attractions': return `/attractions/${item.slug}`;
            case 'eat-drink': return `/eat-and-drink/${item.categories.category_slug}/${item.slug}`;
            case 'shopping': return `/shopping/${item.slug}`;
            case 'current': return `/accommodations/${item.categories.category_slug}/${item.slug}`;
            default: return '/404';
        }
    }
}



// WEBPACK FOOTER //
// /var/www/subdomains/codebnb/hanoigo/public_html/client_user/src/app/accommodations/accommodations.component.ts